// Helper functions

// Add a leading zero if the month or day only contain a single digit
export const padTo2Digits = (num) => {
  return num.toString().padStart(2, '0');
}

// Fotmat Date object to DD/MM/YY format
export const formatDate = (date) => {
  return [
    padTo2Digits(date.getDate()), // DD
    padTo2Digits(date.getMonth() + 1), // MM
    String(date.getFullYear()).slice(2), // YY
  ].join('/');
}

// Return a random string key.
export const getRandkey = () => {
  return Math.random().toString(36).substr(2, 5);
}

//Convert the lang code (fr/en) to a single letter format (F/E)
export const convertLangCodeToSingleLetter = (langCode) => {
  return langCode === 'fr' ? 'F' : 'E';
}

// Display elements outside of the react app.
export const displayOutsideComponents = (components = '') => {
  const compArr = components.split('|');

  if (!compArr) return;

  compArr.forEach(comp => {
    const compEl = document.getElementById(comp);
    if (compEl && compEl.classList.contains('visually-hidden')) {
      compEl.classList.remove('visually-hidden')
    }
  })
}

// Hide elements outside of the react app.
export const hideOutsideComponents = (components = '') => {
  const compArr = components.split('|');

  if (!compArr) return;

  compArr.forEach(comp => {
    const compEl = document.getElementById(comp);
    if (compEl && !compEl.classList.contains('visually-hidden')) {
      compEl.classList.add('visually-hidden')
    }
  })
}

// Format phone number string (without country extension code) to XXX-XXX-XXXX format.
export const formatPhoneNumber = (phoneNumStr) => {
  // Filter only numbers from the input
  const cleaned = ('' + phoneNumStr).replace(/\D/g, '');
  // Check if the input is of correct length
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return match[1] + '-' + match[2] + '-' + match[3];
  }

  console.log('Error: phoneNumStr, ' + phoneNumStr, ', is not in the right format in formatPhoneNumber().')

  return phoneNumStr
};

// Get date ordinal (st, nd, rd, th)
export const getOrdinalNum = (num) => {
  if (num > 3 && num < 21) return 'th';
  switch (num % 10) {
    case 1: return "st";
    case 2: return "nd";
    case 3: return "rd";
    default: return "th";
  }
}

// Set item on localstorage.
export const setItemOnLocalStorage = (key, item) => {
  if (typeof (Storage) !== "undefined") {
    window.localStorage.setItem(key, JSON.stringify(item));
  } else {
    // No web storage support.
    console.log('Error: No web storage support.')
  }
}

// Set item on localstorage.
export const getItemOnLocalStorage = (key) => {
  if (typeof (Storage) !== "undefined") {
    return JSON.parse(window.localStorage.getItem(key));
  } else {
    // No web storage support.
    console.log('Error: No web storage support.')
  }
}

// Auto-format phone number in input element.
export const autoFormatPhoneNumber = (value) => {
  if (!value) return value;

  value = value.replace('+1', '');

  // clean the input for any non-digit values.
  const phoneNumber = value.replace(/[^\d]/g, '');

  const phoneNumberLength = phoneNumber.length;

  if (phoneNumberLength <= 3) return `${phoneNumber}`;

  if (phoneNumberLength <= 6) {
    return `+1 (${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }

  return `+1 (${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)} ${phoneNumber.slice(6, 10)}`;
}

// Strip html element tags
export const stripHTML = (html) => {
  if (!html) return '';
  return html.replace(/(<([^>]+)>)/gi, "").replace('&nbsp;', ' ');
}

// Open a modal.
export const openModal = (elem) => {
  elem.setAttribute('aria-hidden', 'false');
  // Focus the first element within the modal.
  const focusable_selectors = 'a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), *[tabindex]';
  elem.querySelector(focusable_selectors).focus();
  // Make the body unscrollable.
  document.getElementsByTagName('body')[0].classList.add('inactive');
}

// Convert minutes to hours and minites.
export const convertMinutesToHours = (totalMinutes) => {
  if (!totalMinutes) return;

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return {
    hours,
    minutes
  }
}